import { Injectable } from '@angular/core';
import { CompanyEventsService } from './company-events.service';
import { CompanyMember } from '../../shared/models/company/company-member.model';


/**
 * Singleton class to handle parent company service component utils
 */
@Injectable()
export class CompanyParentService {

  public companyMember: CompanyMember;

  constructor(
    private companyEventsService: CompanyEventsService
  ) { }

  /**
   * Opens modal
   * Prevents event delegation and propagation
   * @param {Event} event
   * @param record: data handed to the modal on edit
   */
  public showModal (event: Event, record?: any) {
    event.preventDefault();
    event.stopPropagation();
    this.companyEventsService.openModal(record);
  }

  public openViewAlerts(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.companyEventsService.openViewAlertsModal();
  }
}
